import { render } from "./Storages.vue?vue&type=template&id=603fb571&scoped=true"
import script from "./Storages.vue?vue&type=script&lang=js"
export * from "./Storages.vue?vue&type=script&lang=js"

import "./Storages.vue?vue&type=style&index=0&id=603fb571&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alida\\Desktop\\jupyto\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-603fb571"]])

export default __exports__